<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="order !== null">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.credentials') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
            <button withRight="admin.toolboxcandidate.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus" [disabled]="order.credentials_editable ? null : true"></button>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>

    <app-loader [loading]="loading"></app-loader>

    <ng-container *ngIf="loading !== true">
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'login_url'" [control]="form.get('login_url')" [type]="'input'" [label]="t('common.labels.login_url')" [edit]="inEdit" [basevalue]="order.login_url"></app-form-control>
          <app-form-control [cid]="'login_user'" [control]="form.get('login_user')" [type]="'input'" [label]="t('common.labels.login_user')" [edit]="inEdit" [basevalue]="order.login_user"></app-form-control>
          <app-form-control [cid]="'login_password'" [control]="form.get('login_password')" [type]="'input'" [label]="t('common.labels.login_password')" [edit]="inEdit" [basevalue]="order.login_password"></app-form-control>
          <app-form-control [cid]="'login_informations'" [control]="form.get('login_informations')" [type]="'input'" [label]="t('common.labels.login_informations')" [edit]="inEdit" [basevalue]="order.login_informations"></app-form-control>
        </div>
    </div>
  </ng-container>

  </form>

</ng-container>
